import { OmniReader } from '@scholastic/eds-mediaplayers';
import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

type MainPanelProps = ComponentPropsWithoutRef<typeof OmniReader> & {
  children?: ReactNode;
  className?: string;
};

function MainPanel({
  children,
  className,
  ...props
}: Readonly<MainPanelProps>) {
  return (
    <div
      className={cx('overflow-y auto w-full grow rounded-lg', className)}
      data-testid="story-content"
    >
      <OmniReader {...props} />
      {children}
    </div>
  );
}

export function OmniReaderTemplate({
  className,
  children,
}: Readonly<ComponentPropsWithoutRef<'div'>>) {
  return (
    <div
      className={cx(
        'flex w-full flex-col justify-between px-4 py-4 tablet:px-10 tablet:py-10 laptop:flex-row',
        className
      )}
    >
      {children}
    </div>
  );
}

OmniReaderTemplate.MainPanel = MainPanel;
